// Lightweight components — loaded synchronously (no heavy deps)
import { initTabs } from './ui-components/tabs';
import { initializeAccordion } from './ui-components/accordion';
import { initFeaturesListIndexPage } from './featuresListCardIndexPage';
//import { initializeSupportHeroAnimation } from './supportHeroAnimation';

/**
 * Registry of lazy initializers keyed by the `data-lazy-init` attribute value.
 *
 * Tabs, accordion, and features-list are synchronous — their modules are already
 * in the main bundle, so no extra network round-trip happens on init.
 *
 * Sliders use dynamic imports so Swiper JS + CSS only load when the slider
 * enters the viewport — keeps Swiper out of the render-blocking CSS bundle.
 */
const initializers = {
	'tabs': initTabs,
	'accordion': initializeAccordion,
	'slider-categories': (el) => import(/* webpackChunkName: "slider-categories" */ './slider-category').then(m => m.initSliderCategories(el)),
	'slider-themes':     (el) => import(/* webpackChunkName: "slider-themes" */     './slider-demo-themes').then(m => m.initSliderThemes(el)),
	'slider-video-reviews': (el) => import(/* webpackChunkName: "slider-video-reviews" */ './slider-video-reviews').then(m => m.initSliderVideoReviews(el)),
	'features-list': initFeaturesListIndexPage,
	//'support-hero': initializeSupportHeroAnimation,
};

/**
 * Finds all elements with [data-lazy-init] and sets up an IntersectionObserver
 * to initialize each one the first time it approaches the viewport.
 *
 * Each element is only initialized once — the observer is disconnected from it
 * immediately after the initializer runs.
 */
export function initLazyComponents() {
	const lazyElements = document.querySelectorAll('[data-lazy-init]');

	if (!lazyElements.length) return;

	const observerOptions = {
		root: null,          // viewport
		rootMargin: '100px', // trigger 100px before the element enters the viewport
		threshold: 0         // fire as soon as any pixel is visible
	};

	const lazyObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const elementToInit = entry.target;
				const initType = elementToInit.dataset.lazyInit;

				if (typeof initializers[initType] === 'function') {
					// console.log(`Lazy initializing: ${initType}`, elementToInit);
					initializers[initType](elementToInit);
				} else {
					console.warn(`No lazy initializer found for type: "${initType}"`);
				}

				// Unobserve immediately — each element must only be initialized once.
				observer.unobserve(elementToInit);
			}
		});
	}, observerOptions);

	lazyElements.forEach(element => {
		lazyObserver.observe(element);
	});
}
